<template>
    <b-dropdown
        id="date-range-dropdown"
        variant="outline-secondary"
        size="sm"
        no-caret
        dropleft
        menu-class="custom-dropdown-menu"
        :text="options[selectedKey]"
    >
        <template #button-content>
            <i class="fas fa-calendar-alt mr-2"></i>
            {{ options[selectedKey] }}
            <i class="fas fa-chevron-down ml-2"></i>
        </template>

        <b-dropdown-item
            v-for="(label, key) in options"
            :key="key"
            @click.native.capture="selectKey($event, key)"
        >
            {{ label }}
        </b-dropdown-item>

        <div class="p-3" v-if="customDate">
            <DatePickerRanger
                :opens="esMovil ? 'center' : 'left'"
                @selected="applyCustomRange"
            />
        </div>
    </b-dropdown>
</template>

<script>
    import DatePickerRanger from '@/components/common/forms/DatePickerRanger';

    function formatDate(date) {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    }

    function subtractDays(date, days) {
        const d = new Date(date);
        d.setDate(d.getDate() - days);
        return d;
    }

    const DATE_RANGES = {
        '7d': now => ({
            startDate: formatDate(subtractDays(now, 7)),
            endDate: formatDate(now)
        }),
        '30d': now => ({
            startDate: formatDate(subtractDays(now, 30)),
            endDate: formatDate(now)
        }),
        thisMonth: now => {
            const start = new Date(now.getFullYear(), now.getMonth(), 1);
            return {
                startDate: formatDate(start),
                endDate: formatDate(now)
            };
        },
        lastMonth: now => {
            const year = now.getFullYear();
            const month = now.getMonth();
            const start = new Date(year, month - 1, 1);
            const end = new Date(year, month, 0);
            return {
                startDate: formatDate(start),
                endDate: formatDate(end)
            };
        }
    };

    export default {
        name: 'DateRangePicker',
        props: {
            initialKey: {
                type: String,
                default: '7d'
            }
        },
        data() {
            const now = new Date();
            const initial = DATE_RANGES[this.initialKey](now);
            return {
                selectedKey: this.initialKey,
                dates: initial,
                customDate: false,
                options: {
                    '7d': 'Últimos 7 Días',
                    '30d': 'Últimos 30 Días',
                    thisMonth: 'Mes Actual',
                    lastMonth: 'Último Mes',
                    custom: 'Intervalo Personalizado'
                }
            };
        },
        methods: {
            selectKey(event, key) {
                this.selectedKey = key;
                if (key === 'custom') {
                    event.stopPropagation();
                    this.customDate = true;
                } else {
                    this.customDate = false;
                    this.dates = DATE_RANGES[key](new Date());
                    this.emitChange();
                }
            },
            applyCustomRange(range) {
                const start = new Date(range.startDate);
                const end = new Date(range.endDate);
                this.dates = {
                    startDate: formatDate(start),
                    endDate: formatDate(end)
                };
                this.customDate = false;
                this.selectedKey = 'custom';
                this.emitChange();
            },
            emitChange() {
                this.$emit('change', { ...this.dates });
            }
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        created() {
            this.emitChange();
        },
        components: { DatePickerRanger }
    };
</script>

<style scoped>
.custom-dropdown-menu {
    min-width: 300px !important;
    max-width: 100% !important;
    width: 400px !important;
}
</style>